import { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables';
import { RouteKeys } from '~/router/routes.domain';

export const SafetyRoute: RouteRecordRaw = {
	name: RouteKeys.SAFETY,
	path: 'safety',
	components: {
		default: () => import('../safety/ui/pages/SafetyPage.vue')
	},
	meta: {
		label: 'safety.navigation',
		icon: () => $i('lock'),
		requiresAuth: true,
		isSettingsNavEntry: true,
		isSubEntry: false,
		order: 1
	}
};
